import config from 'src/config';

import httpClient from '@helpers/httpClient';
import {
  FetchInstructorInfoRequestAction,
  HttpFetchInstructorInfoApiResponse,
} from '@redux/instructor/type/instructorType';

const ENDPOINT = '/v1/instructors';

export const INSTRUCTOR_ENDPOINT = {
  INFO: (slug: string) => `${ENDPOINT}/${slug}`,
};

const instructorApi = {
  fetchInstructorInfo: async (
    payload: FetchInstructorInfoRequestAction,
  ): Promise<HttpFetchInstructorInfoApiResponse> => {
    const apiUrl = new URL(INSTRUCTOR_ENDPOINT.INFO(payload.slug), config.API_DOMAIN);
    return httpClient
      .get(apiUrl.toString())
      .then((res) => res.data)
      .catch((error) => error);
  },
};

export default instructorApi;
